import axios from 'axios';
import { datadogRum } from '@datadog/browser-rum';

/**
 * Reports a payroll mutation's failure to RUM unless `collectiveApi` already did.
 *
 * Every request error passes through the `collectiveApi` interceptor, which reports it once, or
 * deliberately leaves out a documented answer. Reporting it again here would count one failure twice
 * and would report the answers the interceptor leaves out. Only an error thrown before any request,
 * such as a client-side check, is reported here.
 */
export default function reportUnlessApiReported(error: unknown, context: object): void {
    if (axios.isAxiosError(error)) {
        return;
    }
    datadogRum.addError(error instanceof Error ? error : new Error(String(error)), context);
}
